/**
 * SidebarPanel — absolute-positioned right panel with CSS slide-in animation.
 * Scoped to the MasterPatternView container (position: absolute, not fixed)
 * so it does not cover the application AppShell.
 *
 * @module components/form/SidebarPanel
 * @see FMPV-MVWC-E003-S001 I-002
 */
import React, { type ReactNode } from 'react';

export interface SidebarPanelProps {
  isOpen: boolean;
  children: ReactNode;
  width?: string;
  onBackdropClick?: () => void;
}

export function SidebarPanel({
  isOpen,
  children,
  width = '480px',
  onBackdropClick,
}: SidebarPanelProps) {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop — covers only the MasterPatternView container */}
      <div
        className="absolute inset-0 bg-black/20 z-20"
        onClick={onBackdropClick}
        aria-hidden="true"
      />
      {/* Panel */}
      <div
        data-testid="sidebar-panel"
        className="absolute right-0 top-0 h-full bg-background-secondary dark:bg-dark-bg-secondary shadow-xl z-30 flex flex-col overflow-hidden"
        style={{ width, willChange: 'transform', transition: 'transform 200ms ease-out' }}
        role="dialog"
        aria-modal="true"
      >
        {children}
      </div>
    </>
  );
}
